import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navItems, whatsappLink } from '../data/mock';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[color:var(--brown-800)]/90 backdrop-blur-md border-b border-[color:var(--gold-500)]/15'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <a href="#top" className="flex flex-col items-center leading-tight">
          <span className="font-serif italic text-3xl text-[color:var(--gold-400)] tracking-widest">A R</span>
          <span className="font-serif text-[10px] text-[color:var(--cream-100)]/80 tracking-widest-2 mt-0.5">
            ANA RODRIGUES
          </span>
          <span className="font-serif text-[8px] text-[color:var(--gold-400)]/80 tracking-widest-2">
            SOCIAL MEDIA
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-[11px] tracking-widest-2 text-[color:var(--cream-100)]/85 hover:text-[color:var(--gold-400)] transition-colors uppercase"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center px-6 py-3 rounded-full border border-[color:var(--gold-400)]/70 text-[11px] tracking-widest-2 text-[color:var(--cream-100)] hover:bg-[color:var(--gold-500)]/15 hover:border-[color:var(--gold-400)] transition-all uppercase"
        >
          Falar com a Ana
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[color:var(--cream-100)]"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[color:var(--brown-800)] border-t border-[color:var(--gold-500)]/15">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-xs tracking-widest-2 text-[color:var(--cream-100)] uppercase"
              >
                {item.label}
              </a>
            ))}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 self-start px-6 py-3 rounded-full border border-[color:var(--gold-400)]/70 text-[11px] tracking-widest-2 uppercase"
            >
              Falar com a Ana
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
